import { createStore } from "vuex";

export default createStore({
  state: {
    railwayTypes: [
      {
        value: "rail",
        label: "Основная ж/д линия",
        style: {
          // Основные ж/д линии — более тёмный серый, как в Google Maps
          color: "#262626",
          weight: 2.5,
          dashArray: "6 6",
        },
      },
      {
        value: "crossover",
        label: "Соединение путей",
        style: {
          // Соединительные участки — чуть светлее и тоньше
          color: "#404040",
          weight: 2,
          dashArray: "5 4",
        },
      },
      {
        value: "siding",
        label: "Боковой путь",
        style: {
          // Боковые пути — средний серый
          color: "#525252",
          weight: 1.5,
          dashArray: "4 3",
        },
      },
      {
        value: "spur",
        label: "Ответвление",
        style: {
          // Ответвления — светлый серый, тонкая линия
          color: "#737373",
          weight: 1,
          dashArray: "3 3",
        },
      },
      {
        value: "yard",
        label: "Служебные пути",
        style: {
          // Сортировочные/служебные пути — самый светлый серый
          color: "#a3a3a3",
          weight: 1,
          dashArray: "2 3",
        },
      },
    ],
    roadTypes: [
      {
        value: "motorway",
        label: "Автомагистраль",
        style: {
          color: "#10b981",
          weight: 3,
          doubleLine: true,
          fill: true,
          lineCap: "butt",
        },
      },
      {
        value: "trunk",
        label: "Республиканская трасса",
        style: {
          color: "#ef4444",
          weight: 2.5,
          doubleLine: true,
        },
      },
      {
        value: "primary",
        label: "Межобластная дорога",
        style: {
          color: "#FBBF24",
          weight: 2,
        },
      },
      {
        value: "secondary",
        label: "Межрайонные дороги",
        style: { color: "#3B82F6", weight: 1.5 },
      },
      {
        value: "tertiary",
        label: "Локальные дороги",
        style: {
          color: "#64748b",
          weight: 1.5,
        },
      },
    ],
  },
  getters: {
    roadTypeStyle(state) {
      return (roadType) => {
        return state.roadTypes.find((type) => type.value === roadType)?.style;
      };
    },
    railwayTypeStyle(state) {
      return (railwayType) => {
        if (!railwayType) return state.railwayTypes[0].style;
        return state.railwayTypes.find((type) => type.value === railwayType)
          ?.style;
      };
    },
  },
  mutations: {},
  actions: {},
  modules: {},
});
